import { FirebaseConnection } from './FirebaseConnection';

export class Authentications {
  email?: string;
  password?: string;

  public constructor(init?: Partial<Authentications>) {
    Object.assign(this, init);
  }

  public async login(con: FirebaseConnection) {
    const result = await con.firebase.auth().setPersistence(con.firebase.auth.Auth.Persistence.SESSION)
      .then(async () => {
        return await con.firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            return true;
          })
          .catch((error: Error) => {
            console.log(error);
            return false;
          });
    })

    return result;
  }
}
